import { Button, Modal, Stack, Typography } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";
import { BIBlack, BIGrey } from "../../../assets/helpers";
import { LoadingButton } from "@mui/lab";
import { ClientEnglishFallback } from "../../constant/ClientEnglishFallback";

function SaveTemplateModal({
  isOpen,
  onClose,
  onSave
  // title = "Save this timesheet as a template to quickly create new Timesheets with the same job, Activities and Crew.",
  // heading = "Save as Template ?"
}) {
  const { loginData, selectedClientData, multiLanguageData } = useSelector((state) => state?.main);
  const { TEXT_NO_THANKS, TEXT_TEMPLATE_SAVE_BTN, TEXT_SAVE_TEMPLATE_DESC, TEXT_SAVE_TEMPLATE } =
    ClientEnglishFallback?.SaveTemplateModal(multiLanguageData?.SaveTemplateModal || {});
  return (
    <Modal open={isOpen} onClose={onClose}>
      <div
        className="client-modal-responsive"
        style={{
          width: "auto"
        }}>
        <Typography fontWeight={600} textAlign={"center"}>
          {TEXT_SAVE_TEMPLATE}
        </Typography>
        <Typography
          mb={1}
          sx={{
            color: BIGrey
          }}>
          {TEXT_SAVE_TEMPLATE_DESC}
        </Typography>
        <Stack direction={"row"} justifyContent={"space-between"} spacing={1}>
          <Button
            sx={{
              textTransform: "none",
              backgroundColor: "#e4e4e4",
              borderRadius: "10px",
              color: BIBlack
            }}
            onClick={onClose}
            fullWidth>
            {TEXT_NO_THANKS}
          </Button>
          <LoadingButton
            loadingPosition="start"
            startIcon={<></>}
            sx={{
              textTransform: "none",
              borderRadius: "10px",
              backgroundColor: selectedClientData?.AccentColor,
              color: "#fff"
            }}
            onClick={onSave}
            fullWidth>
            {TEXT_TEMPLATE_SAVE_BTN}
          </LoadingButton>
        </Stack>
      </div>
    </Modal>
  );
}

export default SaveTemplateModal;
